export const MAX_WIDTH = '1280px'
export const TEST_MAX_WIDTH = '802px'
